/**
 * cx.Caller
 * 类-Caller
 *
 * @class
 * @memberof    cx
 * @author      Zhang Fayong
 * @since       2018-04-28
 */
class Caller
{
  /**
   * 支持两种方式调用 1. Caller(function) 2.Caller(object, 'methodName')
   * @constructor
   */
  constructor()
  {
    if (typeof arguments[0] === 'function')
    {
      this.obj = null
      this.func = arguments[0]
    }
    else if (typeof arguments[0] && typeof arguments[1] === 'string')
    {
      this.obj = arguments[0]
      this.func = arguments[1]
    }
  }

  /**
   * 调用方法
   * @method
   * @param   {Object}    argvs           可变参数
   * @returns {*}
   */
  static call(...argvs)
  {
    let func
    if (this.obj)
    {
      func = this.obj[this.func]
      if (func)
        return func.apply(this.obj, argvs)
    }
    else
    {
      func = this.func
      if (func)
        return func.apply(null, argvs)
    }
  }
}

export default Caller



// WEBPACK FOOTER //
// ./src/lib/Caller.js